export default __webpack_public_path__ + "static/media/use_action_back_xw.180a67fd.png";